import { StyledSvgProps } from 'icons/types';
import styled, { css } from 'styled-components';

const StyledSvgContainer = styled.svg<{ x?: string; y?: string; scale?: number }>`
  ${(props) =>
    props.x &&
    props.y &&
    css`
      transform: scale(${props.scale || 1}) translate(${props.x || 0}, ${props.y || 0});
    `}
`;

const StyledSvg = ({
  scale = 1,
  x,
  y,
  color,
  fill,
  hoverColor,
  xmlns,
  viewBox,
  width,
  height,
  className,
  children,
}: StyledSvgProps) => {
  return (
    <StyledSvgContainer
      width={width}
      height={height}
      color={color}
      viewBox={viewBox}
      fill={fill}
      xmlns={xmlns}
      scale={scale}
      x={x}
      y={y}
      className={className}
    >
      {children}
    </StyledSvgContainer>
  );
};

export default StyledSvg;
